module.exports = __webpack_public_path__ + "static/media/franciscan-life-2022.5e8175ea.jpg";